module.exports = __webpack_public_path__ + "static/media/video.ad8e46af.mp4";